import React from 'react'
import CustomerNotes from '../../shared/CustomerNotes'

interface Props {
  onNoteChange: (value: any) => void
  note: string | any
}

export const RefundedNote: React.FC<Props> = ({onNoteChange, note}) => {
  return (
    <CustomerNotes title='Refund Note' isOpenEditMode onValueChange={onNoteChange} note={note} />
  )
}

export default RefundedNote
